import { useMemo, useEffect } from 'react'

import { useApi } from '@tabeeb/modules/shared/utils/API'
import { useQuery } from '@tanstack/react-query'
import { AIQueryKeys } from '../queries'

interface UseAIObjectHookProps {
  id: number
  onError?: (error: unknown) => void
}

const useAIObject = ({ id, onError }: UseAIObjectHookProps) => {
  const { aiServiceApi: api } = useApi()

  const queryKey = [AIQueryKeys.AIObject, id]
  const query = useQuery({
    queryKey,
    queryFn: () => api.aiObjects.getByIdAsync(id),
    enabled: !!id,
  })

  useEffect(() => {
    if (query.error) {
      onError?.(query.error)
    }
  }, [query.error, onError])

  return useMemo(
    () => ({
      loading: query.isLoading || query.isFetching,
      aiObject: query.data,
    }),
    [query.isLoading, query.isFetching, query.data]
  )
}

export default useAIObject
